import { type FC } from "react";
import { Button, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface ErrorPageProps {
  error?: Error | null;
  onRefresh?: () => void;
}

const ErrorPage: FC<ErrorPageProps> = ({ error, onRefresh }) => {
  const { t } = useTranslation();
  return (
    <Container
      data-testid="error-page"
      maxWidth="sm"
      style={{ textAlign: "center", marginTop: "50px" }}
    >
      <Typography variant="h4" gutterBottom>
        {t("errors.somethingWentWrong")}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          marginBottom: "16px",
        }}
      >
        {t("errors.somethingWentWrongDescription")}
      </Typography>
      {error && (
        <div>
          <Typography
            variant="body1"
            sx={{
              marginBottom: "16px",
            }}
          >
            {error.message}
          </Typography>
        </div>
      )}
      <Button variant="contained" color="primary" onClick={onRefresh}>
        {t("common.refresh")}
      </Button>
    </Container>
  );
};

export default ErrorPage;
